import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { recruitEnvironment } from "@/mocks/legalPages";

/** 採用ページ ENVIRONMENT。3項目を罫線と余白で構成する。 */
export default function RecruitEnvironment() {
  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <Reveal>
          <SectionHeading en={recruitEnvironment.en} jp={recruitEnvironment.heading} />
        </Reveal>

        <Reveal delay={120}>
          <ul className="mt-12 grid grid-cols-1 gap-x-12 gap-y-12 border-t border-foreground-950/12 pt-12 md:mt-16 md:grid-cols-3">
            {recruitEnvironment.items.map((item) => (
              <li key={item.no} className="flex flex-col">
                <span className="font-label text-[12px] tracking-[0.25em] text-secondary-600">
                  {item.no}
                </span>
                <h3 className="mt-6 font-heading text-[17px] leading-[1.7] text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-4 text-[13px] leading-[2] text-foreground-700 md:text-sm">
                  {item.text}
                </p>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}